<template>
  <div>
    <HomeHeaderNavBar></HomeHeaderNavBar>
    <VideoHeader></VideoHeader>
    <VideoList></VideoList>
    <!-- <HomeContentTeaching></HomeContentTeaching> -->

    <HomeFooter></HomeFooter>
    <!-- <Fixed></Fixed> -->
  </div>
</template>

<script>
import HomeHeaderNavBar from "../home/components/HeaderNavBar";
import VideoHeader from "./components/VideoHeader";

import HomeFooter from "../home/components/Footer";
import Fixed from "@/pages/fixed";
import HomeContentTeaching from "./components/ContentTeaching";
import VideoList from "./components/VideoList";

export default {
  name: "Video",
  components: {
    HomeHeaderNavBar,
    VideoHeader,
    VideoList,
    HomeFooter,
    Fixed,
    HomeContentTeaching,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/video/Video.vue